var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbNetworkRulesForms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.068 7.673l-4.11-4.11L8 14.523v4.11h4.11zm3.238-3.238a1.1 1.1 0 0 0 0-1.551L23.748.326a1.1 1.1 0 0 0-1.551 0l-2.142 2.142 4.11 4.11z",
    transform: "translate(-1543 -690) translate(1537.082 689.998)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    transform: "translate(-1543 -690) translate(1543 690)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#838a8e",
    d: "M0 40h24v4.384H0z",
    transform: "translate(-1543 -690) translate(1543 669.617)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbNetworkRulesForms);
export default __webpack_public_path__ + "static/media/rb-network-rules-forms.db2421e4ff8ebc80cc1a1773a84cddb1.svg";
export { ForwardRef as ReactComponent };